module.exports = __webpack_public_path__ + "img/13.3ed7dc8e.jpg";